import { tryCatchHelper } from '../../../../helpers';
import {
  allPlanEvaluacionAction,
  onePlanEvaluacionAction,
} from '../plan_evaluacion/PlanEvaluacionAction';
import { ACTIVO_PLANEVA_TEMAS } from './PlanevaTemasReducer';
import {
  deletePlanevaTemasService,
  onePlanevaTemasService,
  savePlanevaTemasService,
} from './PlanevaTemasService';

export const savePlanevaTemasAction = async (
  { dispatch, notify },
  id,
  data,
  paramsPlanEvaluacion,
) => {
  try {
    const res = await savePlanevaTemasService(id, data);
    notify(res.data.message);
    await onePlanEvaluacionAction(dispatch, data.idPlanEvaluacion);
    await allPlanEvaluacionAction(dispatch, paramsPlanEvaluacion);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPlanevaTemasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PLANEVA_TEMAS, payload: data });
};

export const onePlanevaTemasAction = async (dispatch, id) => {
  const res = await onePlanevaTemasService(id);
  if (res.status === 200) {
    await setActivoPlanevaTemasAction(dispatch, res.data);
    return true;
  }
  return false;
};

export const deletePlanevaTemasAction = async (
  { dispatch, notify },
  idPlanEvaluacion,
  id,
) => {
  try {
    const res = await deletePlanevaTemasService(id);
    notify(res.data.message);
    await setActivoPlanevaTemasAction(dispatch, null);
    await onePlanEvaluacionAction(dispatch, idPlanEvaluacion);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
